"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveBrandBusinessBodyToJSON = exports.RemoveBrandBusinessBodyFromJSONTyped = exports.RemoveBrandBusinessBodyFromJSON = void 0;
function RemoveBrandBusinessBodyFromJSON(json) {
    return RemoveBrandBusinessBodyFromJSONTyped(json, false);
}
exports.RemoveBrandBusinessBodyFromJSON = RemoveBrandBusinessBodyFromJSON;
function RemoveBrandBusinessBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brand': json['brand'],
        'business': json['business'],
    };
}
exports.RemoveBrandBusinessBodyFromJSONTyped = RemoveBrandBusinessBodyFromJSONTyped;
function RemoveBrandBusinessBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brand': value.brand,
        'business': value.business,
    };
}
exports.RemoveBrandBusinessBodyToJSON = RemoveBrandBusinessBodyToJSON;
